/* Memorial Finder — vanilla JS, no deps.
   Product data comes from #mf-products (Liquid), never hard-coded here. */
(function(){
"use strict";
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var root=$("[data-mf-root]"); if(!root) return;

/* ---------- data ---------- */
var PRODUCTS={}, MAP={}, ORDER=["window","porch","garden"];
try{ var cfg=JSON.parse($("#mf-products").textContent); PRODUCTS=cfg.products||{}; MAP=cfg.map||{}; }catch(e){ return; }
var SHOP_DOMAIN=(window.Shopify&&window.Shopify.shop)||window.location.host||"";
var LS_KEY="limency_finder", TTL=30*864e5;
var BREEDS=["Golden Retriever","Labrador","French Bulldog","German Shepherd","Poodle","Chihuahua","Beagle","Dachshund","Husky","Shih Tzu","Yorkshire Terrier","Border Collie","Pit Bull","Cocker Spaniel","Pomeranian","Domestic Shorthair cat","Maine Coon","Siamese","Tabby","Other / mixed"];

var state={audience:null,context:null,pet_name:"",species:null,breed:"",year_from:"",year_to:"",quote:"",ts:0};
var step=0, TOTAL=5, done=false, started=false, resumed=false;

/* ---------- tracking: GA4 (dataLayer/gtag) + Meta Pixel, guarded ---------- */
function track(name,payload){
  payload=payload||{};
  try{ (window.dataLayer=window.dataLayer||[]).push(Object.assign({event:name},payload)); }catch(e){}
  try{ if(typeof window.gtag==="function") window.gtag("event",name,payload); }catch(e){}
  try{
    if(typeof window.fbq==="function"){
      var id="mf_"+name+"_"+Date.now()+"_"+Math.random().toString(36).slice(2,8);
      if(name==="finder_view") window.fbq("track","ViewContent",{content_category:"memorial-finder"},{eventID:id});
      else if(name==="email_capture") window.fbq("track","Lead",{content_category:"memorial-finder"},{eventID:id});
      else window.fbq("trackCustom",name,payload,{eventID:id});
    }
  }catch(e){}
}

/* ---------- persistence ---------- */
function save(){ state.ts=Date.now(); try{ localStorage.setItem(LS_KEY,JSON.stringify(state)); }catch(e){} }
function load(){
  try{ var raw=localStorage.getItem(LS_KEY); if(!raw) return false;
    var s=JSON.parse(raw); if(!s.ts||Date.now()-s.ts>TTL){ localStorage.removeItem(LS_KEY); return false; }
    Object.assign(state,s); return !!(state.pet_name||state.context||state.audience);
  }catch(e){ return false; }
}
function reset(){ state={audience:null,context:null,pet_name:"",species:null,breed:"",year_from:"",year_to:"",quote:"",ts:0}; try{localStorage.removeItem(LS_KEY);}catch(e){} }

/* ---------- helpers ---------- */
var esc=function(s){return String(s==null?"":s).replace(/[<>&"]/g,function(c){return {"<":"&lt;",">":"&gt;","&":"&amp;",'"':"&quot;"}[c]})};
var petName=function(){return (state.pet_name||"").trim()};
var possessive=function(){var n=petName(); if(!n) return "Their"; return n+(/s$/i.test(n)?"'":"'s")};
var dateLine=function(){return (state.year_from&&state.year_to)?state.year_from+" – "+state.year_to:(state.year_from||state.year_to||"")};
function nameSize(base){ var n=petName().length; if(n>=16) return Math.round(base*.72); if(n>=12) return Math.round(base*.85); return base; }
function toast(msg){ var t=$("[data-mf-toast]"); if(!t) return; t.textContent=msg; t.classList.add("on"); clearTimeout(toast._t); toast._t=setTimeout(function(){t.classList.remove("on")},2600); }

/* ETA: same numbers as snippets/product-delivery-estimate.liquid — 2 business days production + 3–7 business days US shipping.
   Business days are converted to calendar days by skipping weekends. */
function addBiz(d,n){ var x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); var w=x.getDay(); if(w!==0&&w!==6) n--; } return x; }
function etaText(p){
  var lo=(p.prod_days||2)+(p.ship_low||3), hi=(p.prod_days||2)+(p.ship_high||7);
  var now=new Date(), a=addBiz(now,lo), b=addBiz(now,hi);
  var f=function(d,m){return d.toLocaleDateString("en-US",m?{month:"short",day:"numeric"}:{day:"numeric"})};
  return f(a,true)+"–"+(a.getMonth()===b.getMonth()?f(b,false):f(b,true));
}

/* ---------- deep link (layer 1) ---------- */
function deepLink(p){
  var q=new URLSearchParams();
  if(petName()) q.set("pet_name",petName());
  if(state.year_from) q.set("year_from",state.year_from);
  if(state.year_to) q.set("year_to",state.year_to);
  if(state.species) q.set("species",state.species);
  if(state.breed) q.set("breed",state.breed);
  if(state.context) q.set("ctx",state.context);
  if(state.audience) q.set("for",state.audience);
  if(state.quote) q.set("quote",state.quote);
  q.set("src","finder");
  return p.url+(p.url.indexOf("?")>-1?"&":"?")+q.toString();
}

/* ---------- BonaPer prefill (layer 2): write the widget's own resume draft ----------
   The storefront widget restores a draft keyed shop|designToken|productHandle from IndexedDB "bonaper-resume"
   (store "drafts"), falling back to localStorage "bonaper:resume:<key>". With sessionStorage
   "bonaper:resume-ask:<key>" = "yes" it hydrates silently, so the customer lands on a form already filled in. */
var designCache={};
function fetchDesign(handle){
  if(designCache[handle]) return designCache[handle];
  var ctrl=("AbortController" in window)?new AbortController():null;
  var t=setTimeout(function(){ if(ctrl) ctrl.abort(); },2500);
  designCache[handle]=fetch("/apps/bonaper/config/"+encodeURIComponent(handle),{headers:{Accept:"application/json"},credentials:"same-origin",signal:ctrl?ctrl.signal:undefined})
    .then(function(r){ clearTimeout(t); if(!r.ok) throw new Error("config "+r.status); return r.json(); })
    .catch(function(e){ clearTimeout(t); delete designCache[handle]; throw e; });
  return designCache[handle];
}
function buildState(doc){
  var st={}, yrs=dateLine();
  (doc.fields||[]).forEach(function(f){
    if(f.kind!=="text") return;
    var tok=String(f.token||""), lab=String(f.label||"").toLowerCase(), tl=tok.toLowerCase();
    if(/name/.test(tl)||/name/.test(lab)){ if(petName()) st[tok]=petName(); }
    else if(/year|date/.test(tl)||/year|date/.test(lab)){ if(yrs) st[tok]=yrs; }
    else if(/quote|line|message/.test(tl)||/quote|message/.test(lab)){ if(state.quote) st[tok]=state.quote; }
  });
  return st;
}
function idbPut(key,val){
  return new Promise(function(res,rej){
    if(!("indexedDB" in window)) return rej(new Error("no idb"));
    var req; try{ req=indexedDB.open("bonaper-resume",1); }catch(e){ return rej(e); }
    req.onupgradeneeded=function(){ req.result.createObjectStore("drafts"); };
    req.onerror=function(){ rej(req.error||new Error("idb open")); };
    req.onsuccess=function(){
      var db=req.result, tx;
      try{ tx=db.transaction("drafts","readwrite"); }catch(e){ db.close(); return rej(e); }
      tx.oncomplete=function(){ db.close(); res(); };
      tx.onerror=tx.onabort=function(){ db.close(); rej(tx.error||new Error("idb tx")); };
      tx.objectStore("drafts").put(val,key);
    };
  });
}
function prefill(p){
  return fetchDesign(p.handle).then(function(doc){
    var key=SHOP_DOMAIN+"|"+doc.token+"|"+p.handle;
    var draft={version:doc.version,state:buildState(doc),at:Date.now(),src:"finder"};
    if(!Object.keys(draft.state).length) return;
    try{ sessionStorage.setItem("bonaper:resume-ask:"+key,"yes"); }catch(e){}
    return idbPut(key,draft).catch(function(){ try{ localStorage.setItem("bonaper:resume:"+key,JSON.stringify(draft)); }catch(e){} });
  });
}

/* ---------- scene: real product photo for the chosen place, with the engraving line as a label ---------- */
var CTX2KEY={window:"suncatcher",porch:"windchime",garden:"stone"};
function scene(){
  var el=$("[data-mf-scene]"); if(!el) return;
  var ctx=state.context, img=$("[data-mf-scene-img]"), lab=$("[data-mf-scene-label]");
  if(ctx&&PRODUCTS[CTX2KEY[ctx]]&&PRODUCTS[CTX2KEY[ctx]].scene){
    var src=PRODUCTS[CTX2KEY[ctx]].scene;
    if(img.getAttribute("src")!==src) img.setAttribute("src",src);
    el.classList.add("single");
  } else { el.classList.remove("single"); }
  if(lab){
    if(petName()){ lab.innerHTML=esc(petName())+(dateLine()?'<small>'+esc(dateLine())+'</small>':'<small>engraved on it</small>'); lab.hidden=false; }
    else lab.hidden=true;
  }
  var cap=$("[data-mf-scene-cap]"); if(cap) cap.textContent=ctx&&MAP[ctx]?MAP[ctx].cap:(cfg.strings.scene_default||"");
}
function engraveLine(){ var n=petName(); if(!n) return ""; return '<p class="mf-engrave">Engraved with <b>'+esc(n)+'</b>'+(dateLine()?' · '+esc(dateLine()):'')+(state.quote?' · “'+esc(state.quote)+'”':'')+'</p>'; }

/* ---------- quiz ---------- */
var S=cfg.strings;
var STEPS=[
  {title:S.q1,hint:S.q1_hint,optional:false,render:function(){return opts("audience",[{v:"self",t:S.q1_self,d:S.q1_self_d},{v:"gift",t:S.q1_gift,d:S.q1_gift_d}])}},
  {title:S.q2,hint:S.q2_hint,optional:false,render:function(){return opts("context",[{v:"window",t:S.q2_window,d:S.q2_window_d},{v:"porch",t:S.q2_porch,d:S.q2_porch_d},{v:"garden",t:S.q2_garden,d:S.q2_garden_d}])}},
  {title:S.q3,hint:S.q3_hint,optional:false,render:function(){return '<div class="mf-field"><label for="mf-pn">'+esc(S.q3_label)+'</label><input class="mf-input" id="mf-pn" type="text" maxlength="18" placeholder="Bella" value="'+esc(state.pet_name)+'" autocomplete="off" autocapitalize="words"></div>'}},
  {title:S.q4,hint:S.q4_hint,optional:true,render:function(){return opts("species",[{v:"dog",t:"Dog"},{v:"cat",t:"Cat"}])+'<div class="mf-field"><label for="mf-br">'+esc(S.q4_breed)+'</label><select id="mf-br"><option value="">'+esc(S.q4_choose)+'</option>'+BREEDS.map(function(b){return '<option'+(state.breed===b?' selected':'')+'>'+esc(b)+'</option>'}).join("")+'</select></div>'}},
  {title:S.q5,hint:S.q5_hint,optional:true,render:function(){return '<div class="mf-field mf-row2"><div><label for="mf-yf">From</label><input class="mf-input" id="mf-yf" inputmode="numeric" maxlength="4" placeholder="2011" value="'+esc(state.year_from)+'"></div><div><label for="mf-yt">To</label><input class="mf-input" id="mf-yt" inputmode="numeric" maxlength="4" placeholder="2024" value="'+esc(state.year_to)+'"></div></div><p class="mf-inline-err" id="mf-yerr">'+esc(S.q5_check)+'</p>'}}
];
function opts(field,list){
  return '<div class="mf-opts" role="group">'+list.map(function(o){return '<button class="mf-opt" type="button" data-field="'+field+'" data-val="'+o.v+'" aria-pressed="'+(state[field]===o.v)+'"><span class="oi">'+(state[field]===o.v?"●":"○")+'</span><span><span class="ot">'+esc(o.t)+'</span>'+(o.d?'<span class="od">'+esc(o.d)+'</span>':'')+'</span></button>'}).join("")+'</div>';
}
function markStart(){ if(!started){ started=true; track("finder_start",{}); } }
function renderStep(){
  var s=STEPS[step];
  $("[data-mf-qtitle]").textContent=(step===2&&state.audience==="gift")?S.q3_gift:s.title;
  $("[data-mf-qhint]").textContent=s.hint;
  $("[data-mf-qcount]").textContent=(step+1)+" of "+TOTAL;
  $("[data-mf-qsr]").textContent="Step "+(step+1)+" of "+TOTAL;
  $("[data-mf-qbody]").innerHTML=s.render();
  $("[data-mf-segs]").innerHTML=Array.apply(null,{length:TOTAL}).map(function(_,i){return '<span class="mf-seg'+(i<step?" done":"")+(i===step?" now":"")+'"></span>'}).join("");
  $("[data-mf-back]").style.visibility=step===0?"hidden":"visible";
  $("[data-mf-skip]").style.display=s.optional?"inline":"none";
  $("[data-mf-next]").textContent=step===TOTAL-1?S.btn_last:S.btn_next;
  validate();
  $$(".mf-opt",$("[data-mf-qbody]")).forEach(function(b){
    b.addEventListener("click",function(){
      markStart(); state[b.dataset.field]=b.dataset.val; save(); renderStep(); scene();
      track("finder_step_"+(step+1),{field:b.dataset.field,value:b.dataset.val});
      if(b.dataset.field!=="species") setTimeout(function(){go(1)},160);
    });
  });
  var pn=$("#mf-pn");
  if(pn){ pn.addEventListener("input",function(){ markStart(); pn.value=pn.value.replace(/[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}]/gu,""); state.pet_name=pn.value; save(); scene(); validate(); }); pn.focus({preventScroll:true}); }
  var br=$("#mf-br"); if(br) br.addEventListener("change",function(){ state.breed=br.value; save(); });
  ["mf-yf","mf-yt"].forEach(function(id,i){ var el=$("#"+id); if(!el) return; if(i===0) el.focus({preventScroll:true});
    el.addEventListener("input",function(){ el.value=el.value.replace(/\D/g,""); state[i===0?"year_from":"year_to"]=el.value; save(); scene(); yearCheck(); }); });
}
function yearCheck(){ var e=$("#mf-yerr"); if(!e) return; var a=+state.year_from,b=+state.year_to; e.classList.toggle("on",!!(state.year_from.length===4&&state.year_to.length===4&&b<a)); }
function validate(){ var ok=true; if(step===0) ok=!!state.audience; if(step===1) ok=!!state.context; if(step===2) ok=petName().length>0; $("[data-mf-next]").disabled=!ok&&!STEPS[step].optional; }
function go(d){
  var nxt=step+d; if(nxt<0) return;
  if(nxt>=TOTAL){ finish(); return; }
  if(d>0 && step>=2) track("finder_step_"+(step+1),{field:step===2?"pet_name":step===3?"species":"years",value:step===2?"set":(step===3?(state.species||""):(state.year_from&&state.year_to?"set":""))});
  step=nxt; renderStep();
  if(window.innerWidth<900) $("[data-mf-quiz]").scrollIntoView({behavior:"smooth",block:"center"});
}

/* ---------- results ---------- */
function finish(){
  var m=MAP[state.context]||MAP.window, best=PRODUCTS[m.best], alts=m.alts.map(function(k){return PRODUCTS[k]}).filter(Boolean);
  if(!best) return;
  $("[data-mf-rtitle]").textContent=petName()?S.r_h2.replace("{PetName}",petName()):S.r_h2_fallback;
  $("[data-mf-rsub]").textContent=state.audience==="gift"?S.r_sub_gift:S.r_sub_self;
  var html=card(best,true,"best")+alts.map(function(p,i){return card(p,false,"alt"+(i+1))}).join("");
  var host=$("[data-mf-cards]"); host.innerHTML=html;
  $$("[data-go]",host).forEach(function(b){ b.addEventListener("click",function(ev){ ev.preventDefault(); goProduct(PRODUCTS[b.dataset.go],b.dataset.pos); }); });
  $$(".mf-card",host).forEach(function(c){ var main=$("[data-mf-main]",c); $$("[data-mf-thumb]",c).forEach(function(t){ t.addEventListener("click",function(){ main.src=t.src.replace(/width=\d+/,"width=900"); $$("[data-mf-thumb]",c).forEach(function(x){x.setAttribute("aria-current",String(x===t))}); }); }); });
  [best].concat(alts).forEach(function(p){ try{ fetchDesign(p.handle).catch(function(){}); }catch(e){} });
  var res=$("[data-mf-results]"); res.classList.add("on"); res.scrollIntoView({behavior:"smooth",block:"start"});
  done=true; updateSticky(); updateGift();
  track("finder_complete",{context:state.context,best:best.key,audience:state.audience});
}
function card(p,isBest,pos){
  var g=(p.gallery||[]).slice(0,4), main=p.card||p.image||g[0]||"";
  return '<article class="mf-card'+(isBest?" best":"")+'"><div class="photo"><img src="'+esc(main)+'" alt="'+esc(p.name)+'" width="900" height="900" loading="lazy" data-mf-main></div>'+
    (g.length>1?'<div class="thumbs">'+g.map(function(u){return '<img src="'+esc(u)+'" alt="" width="52" height="52" loading="lazy" data-mf-thumb aria-current="'+(u===main)+'">'}).join("")+'</div>':'')+
    '<div class="body">'+
    '<span class="mf-tag'+(isBest?"":" alt")+'">'+esc(isBest?S.tag_best:S.tag_alt)+'</span><h3>'+esc(p.name)+'</h3><div class="mf-price">'+esc(p.price)+'</div>'+engraveLine()+
    '<p class="mf-why">'+esc(p.why)+'</p><p class="mf-eta">'+esc(S.eta).replace("{dateRange}",'<b>'+etaText(p)+'</b>')+'</p>'+
    (p.needs_photo?'<p class="mf-why">'+esc(S.photo_note)+'</p>':'')+
    '<a class="mf-btn" href="'+esc(deepLink(p))+'" data-go="'+p.key+'" data-pos="'+pos+'">'+esc(S.btn_card)+'</a></div></article>';
}
var navigating=false;
function goProduct(p,pos){
  if(navigating) return; navigating=true;
  track("result_click",{product:p.key,position:pos||""});
  var url=deepLink(p), gone=false, leave=function(){ if(gone) return; gone=true; window.location.href=url; };
  var guard=setTimeout(leave,1800);
  prefill(p).then(function(){ clearTimeout(guard); leave(); }).catch(function(){ clearTimeout(guard); leave(); });
}

/* ---------- email (S3): stores the lead as a Shopify customer tagged memorial-finder, no reload ---------- */
function wireEmail(){
  var f=$("[data-mf-email-form]"); if(!f) return;
  var msg=$("[data-mf-email-msg]"), inp=$("[data-mf-email]");
  f.addEventListener("submit",function(e){
    e.preventDefault(); var v=(inp.value||"").trim();
    if(!/^\S+@\S+\.\S+$/.test(v)){ msg.textContent=S.email_error; return; }
    var fd=new FormData(); fd.append("form_type","customer"); fd.append("utf8","✓"); fd.append("contact[email]",v);
    fd.append("contact[tags]","memorial-finder"+(state.context?",mf-"+state.context:""));
    fd.append("contact[note]","Memorial Finder — pet: "+petName()+(dateLine()?" ("+dateLine()+")":"")+(state.breed?", "+state.breed:"")+", for: "+(state.audience||"")+", place: "+(state.context||""));
    var btn=$("button",f); btn.disabled=true;
    fetch("/contact",{method:"POST",body:fd,credentials:"same-origin",redirect:"follow"}).then(function(){
      msg.textContent=S.email_success.replace("{PetName}",possessive()); inp.value=""; track("email_capture",{has_name:!!petName()});
    }).catch(function(){ msg.textContent=S.email_error; }).then(function(){ btn.disabled=false; });
  });
}

/* ---------- quotes (S7) ---------- */
function wireQuotes(){
  $$("[data-mf-quote]").forEach(function(c){
    c.setAttribute("aria-pressed",String(state.quote===c.dataset.mfQuote));
    c.addEventListener("click",function(){
      state.quote=c.dataset.mfQuote; save();
      $$("[data-mf-quote]").forEach(function(x){x.setAttribute("aria-pressed",String(x===c))});
      try{ navigator.clipboard&&navigator.clipboard.writeText(state.quote); }catch(e){}
      toast(S.copied); track("quote_copy",{quote:state.quote});
    });
  });
}

/* ---------- gift block (S8), sticky bar, CTA, resume ---------- */
function updateGift(){ var g=$("[data-mf-gift]"); if(g) g.classList.toggle("quiet",state.audience!=="gift"); }
function updateSticky(){ var b=$("[data-mf-sticky-btn]"); if(b) b.textContent=done?S.sticky_after:S.sticky_before; }
function wireSticky(){
  var bar=$("[data-mf-sticky]"); if(!bar) return;
  window.addEventListener("scroll",function(){ bar.classList.toggle("on",window.scrollY>520); },{passive:true});
  $("[data-mf-sticky-btn]").addEventListener("click",function(){ (done?$("[data-mf-results]"):$("[data-mf-quiz]")).scrollIntoView({behavior:"smooth",block:"start"}); });
}
function wireCta(){ $$("[data-mf-cta]").forEach(function(b){ b.addEventListener("click",function(e){ e.preventDefault(); if(!done){ step=0; renderStep(); } $("[data-mf-quiz]").scrollIntoView({behavior:"smooth",block:"center"}); }); }); }
function wireResume(had){
  var r=$("[data-mf-resume]"); if(!r) return;
  if(had){ $("[data-mf-resume-text]").textContent=S.resume.replace("{PetName}",petName()||"you"); r.classList.add("on"); }
  $("[data-mf-resume-reset]").addEventListener("click",function(){ reset(); r.classList.remove("on"); step=0; renderStep(); scene(); updateGift(); });
}

/* ---------- boot ---------- */
var had=load(); step=0;
$("[data-mf-next]").addEventListener("click",function(){go(1)});
$("[data-mf-back]").addEventListener("click",function(){go(-1)});
$("[data-mf-skip]").addEventListener("click",function(){ track("finder_skip",{step:step+1}); go(1); });
$$("[data-mf-shortcut]").forEach(function(a){ a.addEventListener("click",function(){ track("shortcut_click",{collection:a.dataset.mfShortcut}); }); });
renderStep(); scene(); wireEmail(); wireQuotes(); wireSticky(); wireCta(); wireResume(had); updateGift(); updateSticky();
try{
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ track("finder_view",{}); io.disconnect(); } }); },{threshold:.3});
  io.observe($("[data-mf-quiz]"));
}catch(e){ track("finder_view",{}); }
})();
